import { CreateQuotationLayout } from './layouts/CreateQuotation';
import { UpdateQuotationLayout } from './layouts/UpdateQuotation';

export const QuotationPage = ({ action }) => {
  const layouts = {
    create: <CreateQuotationLayout />,
    update: <UpdateQuotationLayout />
  };

  return layouts[action];
};